// Generated by ServiceInterfaceGenerator Aug 28, 2018 11:02:47 AM
import { sharedReactorWebsocket as ws } from '../reactor.js';

class ProjectServiceInterface {
  constructor() {
    this.service_id = 'projectservice-1_0';
  }

  // ProjectListRequest, Response: Boolean
  // tenancyId: int
  getProjectList(tenancyId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectListRequest', { tenancyId: tenancyId }, success_callback);
  }

  // ProjectRequest, Response: Project
  // tenancyId: int
  // projectId: int
  getProject(tenancyId, projectId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectRequest', { tenancyId: tenancyId, projectId: projectId }, success_callback);
  }

  // sends Subscribe to subscribe and Unsubscribe to unsubscribe
  // tenancy_id: int
  subscribeToProjectList(tenancy_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'Subscribe', data: { topic: '/' + this.service_id + '/list/' + tenancy_id, filter: null } };
    var unsubscribe_msg = { service: this.service_id, message: 'Unsubscribe', data: { topic: '/' + this.service_id + '/list/' + tenancy_id } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

}

export const ProjectStateEnum = Object.freeze({
  holding: 'holding',
  started: 'started',
  stopped: 'stopped',
  informing: 'informing'
});

export const ProjectType = Object.freeze({
  anonymous: 'anonymous',
  lite: 'lite',
  authenticated: 'authenticated',
  thirdParty: 'thirdParty',
  agm: 'agm',
  authenticated_anonymous: 'authenticated_anonymous',
  authenticated_lite: 'authenticated_lite'
});

export const projectService = new ProjectServiceInterface();


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/services/projectservice.js
// module id = null
// module chunks = 